/* eslint-disable react/jsx-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import Head from "next/head";
import Image from "next/image";
import Header from "./common/Header";
import Footer from "./common/Footer";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getFaqData } from "../store/actions/faqAction";

const faq = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFaqData());
  }, [dispatch]);
  // console.log(props,'Props +++')
  const faqData = useSelector((state) => state.faqInfo.faqInfo.data);
  // console.log(faqData,'dispatch +++')

  return (
    <div>
      <Head>
        <title>Residen | FAQ</title>
      </Head>
      <Header />
      <div className="innerBannerWrapper">
        <div className="container">
          <div className="innerBannerCaption">
            <h1>FAQ</h1>
            <p>La rubrique pour tout comprendre.</p>
          </div>
        </div>
      </div>
      <div className="padding-top padding-bottom faqWrapper">
        <div className="container">
          <Accordion className="faqAccordion" flush>
            {faqData
              ? faqData.map((item, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{item.question}</Accordion.Header>
                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))
              : null}
          </Accordion>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default faq;
